// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1_8jc","col":"styles_col__X5UPS"};